import Notify from "./notify";
import {sendPatchRequest, sendPostRequest, sendGetRequest} from './apiv4helper';
import {tariffElements, validate} from './OCPITariffFieldsValidation'
import * as Helper from "./OCPITariffHelper";

const i18n = require("i18next");
const priceComponentTypes = ['energy', 'flat', 'time'];

const drawGireveTariffTable = (data) => {
    let tariffTable = $("#gireve-cpo-active-tariff-table tbody");
    generateTable(tariffTable, data);
}

const drawExpiredGireveTariffTable = (data) => {
    let tariffTable = $("#gireve-cpo-expired-tariff-table tbody");
    generateTable(tariffTable, data, false);
}

const generateTable = (tariffTable, tariffList, isActiveTariff = true) => {
    let tableBody = "";
    if (tariffList.length) {
        for (let i = 0; i < tariffList.length; i++) {
            let tariff = tariffList[i];
            tableBody += '<tr>';
            tableBody += '<td>Offer to all</td>';
            let tariffName = '';
            if (tariff.hasOwnProperty('tariff_alt_text') && tariff.tariff_alt_text.length) {
                tariffName = tariff.tariff_alt_text;
            }
            tableBody += '<td>' + tariff.currency + '</td>';
            if (tariffName !== '') {
                tableBody += '<td class="single line"><div class="ui list">';
                $.each(tariffName, function (key, value) {
                    if (value.language === 'en') {
                        value.language = 'gb';
                    }
                    if (value.language === 'ka') {
                        value.language = 'ge';
                    }
                    tableBody += '<div class="item">' +
                        '<i class="' + value.language + ' flag"></i>' + value.text +
                        '</div>';
                });
                tableBody += '</div></td>';
            } else {
                tableBody += '<td>' + tariffName + '</td>';
            }
            tableBody += '<td>';
            tableBody += Helper.getPriceDetails(tariff, false);
            tableBody += '</td>';
            tableBody += '<td>' + tariff.last_updated + '</td>';
            if (isActiveTariff) {
                tableBody += '<td><div class="ui small button update-tariff" data-tariff=\'' + JSON.stringify(tariff) + '\' data-contract-id="' + tariff.credentials_id + '">' + i18n.t('Update') + '</div></td>';
            }
            tableBody += '</tr>';
        }
    }
    tariffTable.html(tableBody);
}

const showEditTariffForm = (tariff, contractId, sellerId, currency) => {
    resetForms();
    let editForm = $(".editTariff");
    $("#tariff_currency").val(currency);
    $(".updateTariffId").val(tariff.id);
    $(".updateContractId").val(contractId);
    $(".updateSellerId").val(sellerId);

    $(".priceDetails").find('.checkbox').checkbox('uncheck');
    $(".details").hide();
    let tariffNames = [];
    const elements = tariff.elements;
    let tariffName = '';
    if (tariff.hasOwnProperty('tariff_alt_text') && tariff.tariff_alt_text.length) {
        tariffName = tariff.tariff_alt_text;
    }
    let tariffNameHTML = '';
    if (tariffName !== '') {
        let i = 1;
        $.each(tariffName, function (key, value) {
            tariffNameHTML += Helper.generateNameField(i, value.text);
            tariffNames[i] = value.language;
            i++;
        });
    } else {
        tariffNames[1] = $('#country_code').val().toLowerCase();
        tariffNameHTML += Helper.generateNameField(1);
    }
    $(".tariffName").html(tariffNameHTML);
    for (let j = 0; j < elements.length; j++) {
        const priceComponents = elements[j].price_components;
        for (let k = 0; k < priceComponents.length; k++) {
            const item = priceComponents[k];
            const priceDetails = $('.update-tariff-modal').find('.priceDetails');
            priceDetails.find(`#ac_${item.type.toLowerCase()}`).val(item.price);
            priceDetails.find(`#dc_${item.type.toLowerCase()}`).val(item.dc_price);
        }
    }
    for (let j = 1; j <= tariffNames.length; j++) {
        if (tariffNames[j] === 'gb') {
            tariffNames[j] = 'en';
        }
        if (tariffNames[j] === 'ge') {
            tariffNames[j] = 'ka';
        }
        $('.language-list-'+j).dropdown('set selected', tariffNames[j]);
    }
    $(".update-tariff-modal").modal('show');
    const $popup = $('.ui.infopopup');
    $popup.popup();
};

const updateTariff = () => {
    updateTariffModalDim();
    const form = $(".editTariff");
    const formIsValid = validate(form, getNameFieldIds());
    if (!formIsValid) {
        updateTariffModalUndim();
        return;
    }
    let data = prepareTariffDataForPost(form.form('get values'));
    if (data['elements'] === undefined || data['elements'].length === 0) {
        alert(i18n.t('roamingManagement.ocpi.price_type_required'));
        return;
    }
    let tariffId = $(".updateTariffId").val();
    let contractId = $(".updateContractId").val();
    let sellerId = $(".updateSellerId").val();
    let modal = $(".update-tariff-modal");
    sendPatchRequest('/admin/roaming/cpo/tariff/' + tariffId + '/' + contractId + '/' + sellerId, data)
        .done(() => {
            updateTariffModalUndim();
            modal.modal('hide');
            $(".show-tariff-modal").modal('hide');
            Notify.success(i18n.t('roamingManagement.ocpi.tariff_updated'));
            loadGireveCPOContracts(sellerId);
        })
        .fail(() => {
            Notify.error(i18n.t('roamingManagement.ocpi.tariff_update_failed'));
            updateTariffModalUndim();
        });
};

const prepareTariffDataForPost = (formData) => {
    return {
        currency: formData.currency,
        tariff_alt_text: getNameFields(),
        tariff_alt_url: formData.tariff_alt_url,
        elements: tariffElements
    };
};

const dim = () => $('body').find('.main-dimmer').addClass('active');

const undim = () => $('body').find('.main-dimmer').removeClass('active');

const updateTariffModalDim = () => $('body').find('.update-tariff-dimmer').addClass('active');

const updateTariffModalUndim = () => $('body').find('.update-tariff-dimmer').removeClass('active');

const resetForms = () => {
    const updateForm = $(".update-tariff-modal");
    const createForm = $(".create-tariff-modal");
    updateForm.find('.tariffName').empty();
    createForm.find('.tariffName').empty();
    priceComponentTypes.forEach(function (value) {
        updateForm.find('.editTariff').form('reset');
        createForm.find('.createTariffForm').form('reset');
        updateForm.find(`#ac_${value}`).val('');
        updateForm.find(`#dc_${value}`).val('');
        createForm.find(`#ac_${value}`).val('');
        createForm.find(`#dc_${value}`).val('');
    });
};

const showGireveRegisterCPOComponent = () => {
    $('#register-gireve-cpo-component').show();
    $('#gireve-cpo-active-tariff-table tbody').html('');
    $('#gireve-cpo-expired-tariff-table tbody').html('');
    $('#manage-gireve-cpo-component').hide();
    $('.gireve-cpo-registration-token').val('');
    showGireveCPOTab();
}

const loadGireveCPOContracts = (sellerId) => {
    dim();
    sendGetRequest('/admin/roaming/gireve/cpo/tariff/' + sellerId)
        .done((data) => {
            updateHTMLWithGireveCPOContracts(data);
            hideGireveInvisibleFields(true);
        })
        .fail((XMLHttpRequest, textStatus, errorMessage) => {
            if (XMLHttpRequest.status == '404') {
                showGireveRegisterCPOComponent();
            } else {
                Notify.error(errorMessage);
            }
            undim();
        });
}

const updateHTMLWithGireveCPOContracts = (data) => {
    $('#register-gireve-cpo-component').hide();
    $('#manage-gireve-cpo-component').show();

    drawGireveTariffTable(data.active_tariffs);
    drawExpiredGireveTariffTable(data.expired_tariffs);

    showGireveCPOTab();
}

const showGireveCPOTab = () => {
    $('body').find('.settings-interface').find('.button').each(function () {
        $(this).removeClass('active');
    });

    $('.cpo-interface').hide();
    $('.emsp-interface').hide();
    $('.gireve-emp-interface').hide();
    $('.show-gireve-cpo').addClass('active');
    $('.gireve-cpo-interface').removeClass('hidden');
    $('.gireve-cpo-interface').show();
    undim();
}

const registerInGireveCPOSystem = (token, sellerId) => {
    dim();
    const data = {
        "token": token,
        "is_gireve": true
    };
    sendPostRequest('/admin/roaming/gireve/cpo/register/' + sellerId, data)
        .done((response) => {
            Notify.success("Gireve CPO registration successful.");
            drawGireveTariffTable(response.data);
            $('#manage-gireve-cpo-component').show();
            $('#register-gireve-cpo-component').hide();
            undim();
        })
        .fail((XMLHttpRequest, textStatus, errorMessage) => {
            Notify.error(errorMessage);
            undim();
        });
}

const hideGireveInvisibleFields = (hidden) => {
    $('.invisible-gireve-field').each(function () {
        $(this).css("display", hidden ? "none" : "block");
    });
}

const getNameFields = () => {
    let nameFields = [];
    $('.update-tariff-name-fields .grid').each(function() {
        const selectedCountry = $(this).find("select").val();
        const text = $(this).find("input[type='text']").val();
        nameFields.push({
            language: selectedCountry,
            text: text
        });
    });
    return nameFields;
}

const getNameFieldIds = () => {
    let nameFieldIds = [];
    $('.update-tariff-name-fields .grid').each(function() {
        nameFieldIds.push($(this).attr('data-id'));
    });
    return nameFieldIds;
}

export {
    showEditTariffForm,
    undim,
    updateTariff,
    drawGireveTariffTable,
    drawExpiredGireveTariffTable,
    registerInGireveCPOSystem,
    hideGireveInvisibleFields,
    loadGireveCPOContracts
};
